export const anyCutoff = 65535;

export const cutoffOptions: SelectorOption<number>[] = [
  {
    label: "Any",
    value: anyCutoff,
  },
];
